import { GRID_FORM_CONFIG_T } from "../../../../common/FormGenerator"
import { Select, MenuItem } from "@mui/material"
import { IconArrowDown } from "../../../../icons/IconArrowDown"
import { MenuItemStyled, MenuListStyled, MenuPaperStyled, SelectStyle } from "./style"

export type CommentsFilterBlockName =
  | "commentsSort"

export type CommentsSortFormOptions = {
  /** Select внутри SwipeableDrawer (mobile): Menu без portal, иначе onChange не срабатывает. */
  menuInModal?: boolean
}

const sortMenuItems = [
  <MenuItem key="new" sx={MenuItemStyled} value="new">Сначала новые</MenuItem>,
  <MenuItem key="old" sx={MenuItemStyled} value="old">Сначала старые</MenuItem>,
  <MenuItem key="interesting" sx={MenuItemStyled} value="interesting">Сначала интересные</MenuItem>,
]

export const buildCommentsSortFormConfig = (
  options: CommentsSortFormOptions = {},
): GRID_FORM_CONFIG_T<any> => [
  [
    {
      id: 1,
      controllerName: "sort",
      RenderElement: Select,
      renderProps: () => ({
        IconComponent: IconArrowDown,
        sx: SelectStyle,
        MenuProps: {
          disablePortal: options.menuInModal === true,
          disableScrollLock: options.menuInModal === true,
          PaperProps: {
            sx: options.menuInModal
              ? { ...MenuPaperStyled, zIndex: 1400 }
              : MenuPaperStyled,
          },
          MenuListProps: { sx: MenuListStyled },
        },
        children: sortMenuItems,
      }),
    },
  ],
]

export const commentsSortConfig = buildCommentsSortFormConfig()

const formConfigs: Record<CommentsFilterBlockName, GRID_FORM_CONFIG_T<any>> = {
  commentsSort: commentsSortConfig,
}

export const getFormConfig = (
  blockName: CommentsFilterBlockName,
  options?: CommentsSortFormOptions,
) => {
  if (blockName === "commentsSort" && options) {
    return buildCommentsSortFormConfig(options)
  }
  return formConfigs[blockName]
}
